import { RigFracActivityMetric, RigFracGroupBy } from "constants/charts.enums";
import { createMergeWithDefaults } from "entities/utils";
import { RigFracRecentActivityChartRequestType } from "types";

import { RIG_FRAC_PLASMA_PALETTE } from "./rigFracColorPalette";

// Lean request for the Rig/Frac Recent Activity chart (EVA-76). Same endpoint
// as Activity Over Time, discriminated by chartType; a SINGLE `metric` (not
// left/right) and no time-scale fields — see specs/EVA-76-recent-activity/.
export const DEFAULT_RIG_FRAC_RECENT_ACTIVITY_REQUEST: RigFracRecentActivityChartRequestType =
  {
    chartType: "RigFracRecentActivity",
    metric: RigFracActivityMetric.RigCount,
    groupBy: RigFracGroupBy.Operator,
    filters: {},
    bbox: null,
    // Default palette is Plasma (see useRigFracActivityController for the
    // merge-safe post-assignment of the effective palette).
    colorPalette: RIG_FRAC_PLASMA_PALETTE
  };

export const generateRigFracRecentActivityRequestBody = createMergeWithDefaults(
  DEFAULT_RIG_FRAC_RECENT_ACTIVITY_REQUEST
);
